export default "__VITE_ASSET__D9AAMklU__"